import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './DarkThemeApp';

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);

root.render(
  <App />
);